module.exports = __webpack_public_path__ + "img/koakuma_sc1.06c26457.png";